// v3.15-957/v3.15-969 — frontend predicate matching the backend
// `_user_can_use_booking()`. Returns true ONLY when the current user's
// company is internal (PTC staff) OR has company.name === "PTC".
//
// HIDE booking UI for everyone else (Tradeline International, all external
// companies, all partner users).
//
// Anywhere booking UI shows up — Schedule button, Copy Booking Link, the
// Dashboard slug-issues warning, etc. — must be wrapped in this guard.

const ALLOWED_COMPANY_NAMES = new Set([
  'ptc',
]);

export const userCanUseBooking = (user) => {
  if (!user) return false;
  // Internal PTC staff — always allowed.
  if ((user.company_type || '').trim().toLowerCase() === 'internal') return true;
  // External company whose name is literally "PTC" (case-insensitive).
  const name = (user.company_name || '').trim().toLowerCase();
  if (ALLOWED_COMPANY_NAMES.has(name)) return true;
  // Some auth payloads only carry company_id — fall back to a known
  // canonical PTC company id if it ever ships through.
  const id = user.company_id || '';
  if (id && (window.__PTC_COMPANY_IDS__ || []).includes(id)) return true;
  return false;
};
